const SITE_BASE = 'https://harukawaii.cn';

function ensureMeta(selector: string, create: () => HTMLMetaElement): HTMLMetaElement {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

export function setPageMeta(opts: { title: string; description: string; keywords?: string; path?: string }) {
  document.title = opts.title;
  ensureMeta('meta[name="description"]', () => {
    const m = document.createElement('meta');
    m.name = 'description';
    return m;
  }).setAttribute('content', opts.description);

  if (opts.keywords) {
    ensureMeta('meta[name="keywords"]', () => {
      const m = document.createElement('meta');
      m.name = 'keywords';
      return m;
    }).setAttribute('content', opts.keywords);
  }

  const path = opts.path || '/';
  const canonicalUrl = `${SITE_BASE}${path === '/' ? '/' : path}`;

  const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (canonical) canonical.setAttribute('href', canonicalUrl);

  ensureMeta('meta[property="og:title"]', () => {
    const m = document.createElement('meta');
    m.setAttribute('property', 'og:title');
    return m;
  }).setAttribute('content', opts.title);
  ensureMeta('meta[property="og:description"]', () => {
    const m = document.createElement('meta');
    m.setAttribute('property', 'og:description');
    return m;
  }).setAttribute('content', opts.description);
  ensureMeta('meta[property="og:url"]', () => {
    const m = document.createElement('meta');
    m.setAttribute('property', 'og:url');
    return m;
  }).setAttribute('content', canonicalUrl);
  ensureMeta('meta[name="twitter:title"]', () => {
    const m = document.createElement('meta');
    m.name = 'twitter:title';
    return m;
  }).setAttribute('content', opts.title);
  ensureMeta('meta[name="twitter:description"]', () => {
    const m = document.createElement('meta');
    m.name = 'twitter:description';
    return m;
  }).setAttribute('content', opts.description);
}

export function injectJsonLd(data: object): () => void {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo', 'guaji');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
  return () => {
    script.remove();
  };
}

export function clearJsonLd() {
  document.head.querySelectorAll('script[data-seo="guaji"]').forEach((s) => s.remove());
}

export function buildWebSiteLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '瓜迹 · 吃瓜事件时间轴',
    url: SITE_BASE,
    description: '按节点梳理每起热点事件的经过与进展，从爆发到后续追踪的吃瓜事件时间轴平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_BASE}/events?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function buildBreadcrumbLd(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: `${SITE_BASE}${it.path}`,
    })),
  };
}

export { SITE_BASE };